import { Text } from "@meditect/medibase-components";

export const SalesCannotRefundUnsettledSaleError = () => {
  return (
    <Text>Cette vente n'est pas encore réglée : seule une vente clôturée ou à encaisser peut être remboursée.</Text>
  );
};
